<template>
	<div class="flash-container alerts">
		<div class="community-alert">
			<transition-group name="flash-message" tag="div">
				<Flash v-for="(f, fi) in flash" :key="fi" :options="f"></Flash>
			</transition-group>
		</div>
	</div>
</template>

<script>
import Flash from './Flash'
import { mapState } from 'vuex'

export default {
	name: 'flash-messages',
	components: {
		Flash
	},
	computed: {
		...mapState({
			flash: 'flash'
		})
	}
}
</script>
